import { useLoyaltyContext, useUserSession } from '@libs/common-next';
import { CurrentTierLevel } from '@libs/common-types';
import { invariant } from '@libs/core';

type UseAccountAuthenticated = {
    loyaltyData: {
        availableDollars: string;
        availablePoints: string;
        currentTierLevel: CurrentTierLevel;
    } | null;
    firstName: string;
};

function formatPoints(points: number) {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(points);
}

export function useAccountAuthenticated(): UseAccountAuthenticated {
    const { memberPoints, isLoyaltyUnavailable } = useLoyaltyContext();
    const { userData } = useUserSession();

    const profile = userData?.profile;

    invariant(profile, 'Authenticated account requires a profile');

    const { firstName } = profile;

    if (isLoyaltyUnavailable || !memberPoints) {
        return {
            loyaltyData: null,
            firstName,
        };
    }

    const { availableDollars, availablePoints, currentTierLevel } = memberPoints;

    return {
        loyaltyData: {
            availableDollars: availableDollars.toFixed(2),
            availablePoints: formatPoints(availablePoints),
            currentTierLevel,
        },
        firstName,
    };
}
